module.exports = __webpack_public_path__ + "static/img/14000616.6538caf7.png";